<style lang="scss" scoped>
button {
  display: inline-block !important;
  margin-top: 30px;
  width: auto;
  font-weight: 700;
  color: $c-white;
  border: 0;
  letter-spacing: 1px;
  position: relative;

  //border:1px solid red;
  padding-right: 60px;
  letter-spacing: 2px;

  span {
    //border:1px solid red;
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: $c-salmon;
    transition: all 200ms ease;
    svg {
      fill: #fff;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &:hover {
    span {
      background: $c-salmon-60;
    }
  }
}
</style>

<template>
  <LoginContainer>
    <button @click="login">
      {{ $t('login.login') }}<span class="arrow"><Icon :path="mdiChevronRight" :width="40" :height="40" /></span>
    </button>
  </LoginContainer>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

import { useRouter } from 'vue-router';
import { mdiChevronRight } from '@mdi/js';

import LoginContainer from '@/components/LoginContainer.vue';

export default defineComponent({
  components: {
    LoginContainer,
  },
  setup() {
    const router = useRouter();

    router.push({ name: 'Login' });

    const login = () => {
      router.push({ name: 'Login' });
    };

    return {
      login,
      mdiChevronRight,
    };
  },
});
</script>
